import { get, post, postRaw } from 'services/api';

export const FETCH_LISTS_URL = '/lists/data.json';
export const FETCH_LIST_SIZE = '/i/lists/getSize?listId=';
export const DELETE_LIST = '/lists/delete?emailListId=';
export const FETCH_LIST_COUNTS = '/i/lists/counts';
export const CREATE_IMPORT_LIST = '/lists/importSubmit';
export const RENAME_LIST = '/lists/rename';
export const DELETE_LIST_ENDPOINT = '/lists/delete';
export const FETCH_LIST_SIZE_ENDPOINT = '/i/lists/getSize';

/**
 * fetchListSize
 * gets the size of a list by id
 * @return { number } Size of list
 */
export function fetchListSize(id) {
  return get(`${FETCH_LIST_SIZE}${id}`);
}

/**
 * fetchLists
 * gets a JSON list of lists
 * @return { Object[] } Object containing lists
 */
export function fetchLists(params) {
  return post(FETCH_LISTS_URL, params);
}

/**
 * deleteList
 * delete a list given the id
 * @return { Object[] } Updated list without deleted list
 */
export function deleteList(id) {
  return postRaw(`${DELETE_LIST}${id}`);
}

/**
 * fetchListCounts
 * gets the counts of each list type
 * @return { Object[] } Updated list without deleted list
 */
export function fetchListCounts() {
  return get(FETCH_LIST_COUNTS);
}
